import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconBasedContentBox } from "../icon-based-content-box/icon-based-content-box";
import { FontAwesomeDuoToneStyle } from "../../fontawesome";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    actionLink: {
        color: theme.palette.primary.main
    }
}));

export const Documents = ({
    documents
}) => {
    const classes = useStyles();
    
    return (
        documents != null ?
            <>
                {
                    documents.map(x => (
                        <IconBasedContentBox key={x.documentId} icon={<FontAwesomeIcon icon={["fad", "paperclip"]} style={FontAwesomeDuoToneStyle} />}>
                            <a href={x.fullFilePath} className={classes.actionLink} download={x.name}>{x.name}</a>
                        </IconBasedContentBox>
                    ))
                }
            </> : 
            null
    );
}